import {useContext} from 'react';
import {StatusPageContext} from '@/status_pages/display/context/StatusPageContextProvider';

export const useStatusPageContext = () => {
  return useContext(StatusPageContext);
};
